import React, { useEffect, useState } from "react";
import { Table, Button, Modal, message, Popconfirm, Layout } from "antd";
import { getSubscriptionAudiences } from "../../api/subscription_audiences/subscriptionAudiencesRequest";
import { getSubscriptionTypes } from "../../api/subscription_types/subscriptionTypesRequest";
import SubscriptionAudienceForm from "./SubscriptionAudienceForm";
import PermissionRender from "../../components/PermissionRender";

const { Content } = Layout;

const SubscriptionAudiencesPage = () => {
  const [audiences, setAudiences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingAudience, setEditingAudience] = useState(null);
  const [subscriptionTypes, setSubscriptionTypes] = useState([]);

  useEffect(() => {
    fetchAudiences();
    fetchSubscriptionTypes();
  }, []);

  const fetchAudiences = async () => {
    setLoading(true);
    try {
      const data = await getSubscriptionAudiences();
      setAudiences(data);
    } catch (error) {
      message.error("Erreur lors du chargement des audiences");
    } finally {
      setLoading(false);
    }
  };

  const fetchSubscriptionTypes = async () => {
    try {
      const data = await getSubscriptionTypes();
      setSubscriptionTypes(data);
    } catch (error) {
      message.error("Erreur lors du chargement des types d'abonnement");
    }
  };

  const handleCreate = () => {
    setEditingAudience(null);
    setModalVisible(true);
  };

  const handleEdit = (audience) => {
    setEditingAudience(audience);
    setModalVisible(true);
  };

  const handleModalOk = () => {
    setModalVisible(false);
    setEditingAudience(null);
    fetchAudiences();
  };

  const columns = [
    { title: "ID", dataIndex: "id", key: "id" },
    { title: "Nom", dataIndex: "name", key: "name" },
    { title: "Description", dataIndex: "description", key: "description" },
    {
      title: "Type d'abonnement",
      dataIndex: "subscription_type_id",
      key: "subscription_type_id",
      render: (id) => subscriptionTypes.find((t) => t.id === id)?.name || "-",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <PermissionRender
            requiredPermission={["subscription_audience", "update"]}
          >
            <Button
              onClick={() => handleEdit(record)}
              size="small"
              style={{ marginRight: 8 }}
            >
              Modifier
            </Button>
          </PermissionRender>
        </>
      ),
    },
  ];

  return (
    <Layout className="min-h-screen">
      <Content className="py-6 sm:px-6 lg:px-8">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 16,
          }}
        >
          <h2>Audiences d'abonnement</h2>
          <PermissionRender
            requiredPermission={["subscription_audience", "create"]}
          >
            <Button type="primary" onClick={handleCreate}>
              Nouvelle audience
            </Button>
          </PermissionRender>
        </div>
        <Table
          columns={columns}
          dataSource={audiences}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 10 }}
        />
        <Modal
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          footer={null}
          destroyOnClose
          title={editingAudience ? "Modifier l'audience" : "Nouvelle audience"}
        >
          <SubscriptionAudienceForm
            audience={editingAudience}
            subscriptionTypes={subscriptionTypes}
            onSuccess={handleModalOk}
            onCancel={() => setModalVisible(false)}
          />
        </Modal>
      </Content>
    </Layout>
  );
};

export default SubscriptionAudiencesPage;
